import { useEffect } from "react";
import cookiesMd from "../content/policies/cookies.md?raw";
import { renderMarkdown } from "../lib/markdown";
import { CookiePreferencesLink } from "../components/ConsentPreferences";
import { EditorialPage } from "../components/editorial";
import Navbar from "../components/Navbar";
import StoryPageHero from "../components/story/StoryPageHero";

// Derived, not hardcoded — same reason as PrivacyPage and TermsPage. This page
// happens to still be accurate (cookies.md really is 2026-05-25 / v2.0), so it
// is fixed while it is right rather than after it drifts like the terms did.

export default function CookiesPage() {
  useEffect(() => {
    document.title = "Cookie Policy | LetsLoop";
  }, []);

  return (
    <>
      <Navbar />
      <EditorialPage>
        {/* Header band only. The policy body keeps its plain styling: these
            pages are read for meaning, and decorating running legal text makes
            it harder rather than better. */}
        <StoryPageHero
          kicker="cookies"
          title={<>What we set, and what you can turn off.</>}
          marks={[
            {
              name: "loop",
              size: 58,
              rotate: 8,
              className: "right-[8%] top-[30%] text-teal/25",
            },
          ]}
        >
          <div className="flex flex-col md:flex-row md:items-center gap-4 pb-2">
            <CookiePreferencesLink className="inline-flex items-center justify-center px-5 py-2.5 rounded-full text-sm font-bold bg-salmon text-on-salmon hover:bg-salmon transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-salmon focus-visible:ring-offset-2">
              Manage cookie preferences
            </CookiePreferencesLink>
          </div>
        </StoryPageHero>

        <article className="relative max-w-3xl mx-auto px-4 md:px-6 pt-4 pb-16 md:pb-24">
          {renderMarkdown(cookiesMd)}
        </article>
      </EditorialPage>
    </>
  );
}
